import { DateTime } from "luxon"
import elementTypes from "../Elements/elementTypes"

export function getNewQuestion(type) {
  const allElements = [
    ...elementTypes.basicElements,
    ...elementTypes.specialElements,
  ]
  const thisElement = allElements.find((element) => element.id === type)

  let options = []
  if (elementTypes.propertiesConfig.hasOptions.includes(type)) {
    options = [
      getNewQuestionOption("Option 1"),
      getNewQuestionOption("Option 2"),
    ]
  }

  let questionLabels = []
  if (elementTypes.propertiesConfig.hasQuestionLabels.includes(type)) {
    questionLabels = [getNewMatrixQuestionLabel("Question 1")]
  }

  let questionText = ""
  let questionHelpText = ""
  let optionAlignment = "vertical"

  if (elementTypes.headingElementId === type) {
    questionText = "New heading"
    questionHelpText = ""
    optionAlignment = "left"
  } else if (elementTypes.descriptionElementId === type) {
    questionText = "New description"
    questionHelpText = undefined
    optionAlignment = "left"
  }

  return {
    id: DateTime.now().toUTC().toISO(),
    text: questionText,
    helpText: questionHelpText,
    scoreFromAnswer: false,
    type: type,
    groupOrder: 1,
    required: false,
    width: "100%", //Indicates width of the input component
    height: 3, //Used for paragraph to indicate row height & Header for font size (H1-H3)
    isConditional: false,
    conditionalSource: undefined,
    conditionalType: undefined,
    conditionalValue: "",
    optionAlignment: optionAlignment,
    options: options,
    questionLabels: questionLabels,
    defaultValue: "",
    minValue: "",
    maxValue: "",
    verifyAge: false,
    minAge: 12,
    allowFutureDates: true,
    allowPastDates: true,
    isActive: true,
    isNew: true,
  }
}

export function getNewQuestionGroup() {
  const newGroup = {
    id: DateTime.now().toUTC().toISO(),
    name: "",
    alignment: "vertical",
    expanded: true,
    groupOrder: 1,
    questions: [],
    isDeleted: false,
    isNew: true,
  }

  return newGroup
}

export function getNewQuestionOption(defaultText) {
  return {
    id: `${DateTime.now().toUTC().toISO()}_${defaultText}`,
    text: defaultText || "",
    scoreValue: 1,
    isDeleted: false,
    isNew: true,
    orderNumber: 1,
  }
}

export function getNewMatrixQuestionLabel(defaultText) {
  return {
    id: DateTime.now().toUTC().toISO(),
    text: defaultText || "",
    isDeleted: false,
    isNew: true,
    orderNumber: 1,
  }
}

export function GetNewOrderEntry(type, orderNumber) {
  let question =
    type !== elementTypes.groupElementId ? getNewQuestion(type) : undefined
  let group =
    type === elementTypes.groupElementId ? getNewQuestionGroup() : undefined

  return {
    id: `orderId${orderNumber}`,
    questionGroup: group,
    question: question,
    orderNumber: orderNumber,
    isNew: true,
    isDeleted: false,
  }
}
